import { createContext, useContext, useMemo } from 'react';
import { Metadata } from '@goldcast/player-config/src/types/RemotionPlayerConfigTypes/Metadata/Metadata';

const PlayerConfigMetadataContext = createContext<{ metadata: Metadata | undefined }>({ metadata: undefined });

export const PlayerConfigMetadataProvider = ({
  children,
  metadata
}: {
  metadata: Metadata | undefined;
  children: React.ReactNode;
}) => {
  const _metadata = useMemo(() => {
    return { metadata };
  }, [metadata]);

  return <PlayerConfigMetadataContext.Provider value={_metadata}>{children}</PlayerConfigMetadataContext.Provider>;
};

export const usePlayerConfigMetadata = () => {
  return useContext(PlayerConfigMetadataContext);
};
